{
    "Accessibility menu": "Мени приступачности",
    "Close": "Затвори",
    "Content adjustments": "Прилагођавања садржаја",
    "Navigation adjustments": "Прилагођавања навигације",
    "Text Align": "Поравнање текста",
    "Align Left": "Поравнај лево",
    "Align Center": "Поравнај по средини",
    "Align Right": "Поравнај десно",
    "Adjust Font Size": "Подеси величину фонта",
    "Highlight Title": "Истакни наслов",
    "Highlight Links": "Истакни линкове",
    "Readable Font": "Читљив фонт",
    "Colour adjustments": "Прилагођавања боја",
    "Dark Contrast": "Тамни контраст",
    "Light Contrast": "Светли контраст",
    "High Contrast": "Високи контраст",
    "High Saturation": "Висока засићеност",
    "Low Saturation": "Ниска засићеност",
    "Monochrome": "Монохроматски",
    "Tools": "Алати",
    "Reading Guide": "Водич за читање",
    "Big Cursor": "Велики курсор",
    "Increase Font Size": "Повећај величину фонта",
    "Decrease Font Size": "Смањи величину фонта",
    "Letter Spacing": "Размак између слова",
    "Line Height": "Висина линије",
    "Font Weight": "Дебљина фонта",
    "Dyslexia Font": "Фонт за дислексију",
    "Language": "Језик",
    "Accessibility widget": "Отвори мени приступачности",
    "Accessibility Profiles": "Профили приступачности",
    "Cognitive Disability": "Когнитивна инвалидност",
    "Seizure Safe": "Безбедно за нападе",
    "Accessibility statement": "Изјава о приступачности",
    "ADHD": "ADHD",
    "Low Vision": "Слаб вид",
    "Pause Animations": "Заустави анимације",
    "Animation paused": "Анимација је паузирана",
    "Reset all settings": "Ресетуј подешавања",
    "Shortcut:": "Пречица:",
    "Epilepsy Safe Mode": "Режим безбедан за епилепсију",
    "Mute sounds": "Искључи звукове",
    "Page read": "Читање странице",
    "Page read controls": "Контроле читања странице",
    "Pause": "Паузирај",
    "Resume": "Настави",
    "Stop": "Заустави",
    "Settings": "Подешавања",
    "Speed": "Брзина",
    "Voice": "Глас",
    "Close accessibility menu": "Затвори мени приступачности",
    "Back to accessibility menu": "Назад на мени приступачности",
    "Search languages": "Претражи језике",
    "Selected language": "Изабрани језик",
    "View accessibility statement (opens in new window)": "Прикажи изјаву о приступачности (отвара се у новом прозору)",
    "Visit CookieYes website (opens in new window)": "Посетите веб-сајт CookieYes (отвара се у новом прозору)",
    "Reset all accessibility settings to default": "Врати сва подешавања приступачности на подразумевана"
}
